import ParentDetails from "./ParentDetails";
import StudentDetails from "./StudentDetails";
import { useDispatch, useSelector } from "react-redux";
import { resetUserDataForm, setCurrentStep, setSelectedRole } from "../../redux/Slices/profileSetupSlice";
import { RootState } from "../../redux/Store/store";
import { useNavigate } from "react-router-dom";
import { useLazyProfileStatusQuery } from "../../redux/API/ProfileSetup/profileSetupApi";
import { useEffect } from "react";
import sat from "../../assets/Images/SATprep1.svg";
import Horizontallogo  from "../../assets/Images/VerticalDarkLogo1.svg";
import OnboardingBackground from "../../components/ReUsableComponents/OnboardingBackground";

const ProfileSetup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { selectedRole,currentStep} = useSelector(
    (state: RootState) => state.root.profileSetupSlice
  );

  const [profileStatus] = useLazyProfileStatusQuery();
  const handleRoleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = event.target
    dispatch(setSelectedRole(value));
    dispatch(resetUserDataForm());
    if(value === 'parent'){
      dispatch(setCurrentStep('parentPersonalDetails'))
    }else {
      dispatch(setCurrentStep('studentPersonalDetails'))
    }
  };

  const getProfileStatus = async () => {
    try {
      const response = await profileStatus({}).unwrap();
      if (response.status === "success") {
        if(response?.data?.isProfileVerified){
          navigate("/dashboard");
        } 
      }else{
        navigate("/login");
      }
    } catch (error) {
      navigate('/login');
      console.error(error);
    }
  }

  useEffect(() => {
    getProfileStatus();
  },[])

  return (
    <OnboardingBackground>
      <div className=" bg-satPrepTransWhite p-10 rounded-3xl shadow-error-screen w-[720px] flex flex-col items-center border border-gray-200 font-gully my-10">
        <div className="flex flex-col justify-between w-full items-center">
          <img src={Horizontallogo} alt="Horizontallogo" className="h-[163px] w-[260px]" />
          <img src={sat} alt="SAT Prep Logo" className="h-[68px] w-[211px]" />
        </div>
        {currentStep === "studentParentDetails" &&
        selectedRole === "student" ? (
          <ParentDetails />
        ) : currentStep === "parentStudentDetails" &&
          selectedRole === "parent" ? (
          <StudentDetails />
        ) :  (
          <>
            <p className="font-bold text-satPrepAccent text-center text-[40px] font-pretendard cursor-pointer">
              Let’s setup your profile
            </p>
            <div className="w-full my-9">
              <div className="flex justify-center items-center text-[21px] font-medium">
                <p className="mr-9">I am a </p>
                <label className="role">
                  <span className="ml-3 mr-9">Student</span>
                  <input
                    value="student"
                    type="radio"
                    name="radio"
                    checked={selectedRole === "student"}
                    onChange={handleRoleChange}
                  />
                  <span className="checkmark"></span>
                </label>{" "}
                <label className="role">
                  <span className="ml-3">Parent</span>
                  <input
                    value="parent"
                    type="radio"
                    name="radio"
                    checked={selectedRole === "parent"}
                    onChange={handleRoleChange}
                  />
                  <span className="checkmark"></span>
                </label>{" "}
              </div>
            </div>
            {/* student */}
            <div className="w-[446px]">
              {selectedRole === "student" ? (
                <StudentDetails />
              ) : (
                <ParentDetails />
              )}
            </div>
          </>
        )}
      </div>
    </OnboardingBackground>
  );
};

export default ProfileSetup;
